import * as tslib_1 from "tslib";
import InboxRuleRow from './InboxRuleRow';
import InboxRulesEdit from './InboxRulesEdit';
import generateInboxRuleDiagnosticReport from '../actions/generateInboxRulesDiagnosticReport';
import getInboxRules from '../actions/getInboxRules';
import initializeInboxRulesFolders from '../actions/helpers/initializeInboxRulesFolders';
import isInboxRuleOptionEditState from '../actions/helpers/isInboxRuleOptionEditState';
import setInboxRuleDiagnosticRequestStatus from '../actions/helpers/setInboxRuleDiagnosticRequestStatus';
import initializeInboxRuleEdit from '../actions/initializeInboxRuleEdit';
import store from '../store/store';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { ActionButton } from 'office-ui-fabric-react/lib/Button';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { Spinner, SpinnerType } from 'office-ui-fabric-react/lib/Spinner';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var styles = require('./InboxRulesFullCSS.scss');
var className = require('classnames/bind').bind(styles);
var InboxRulesFull = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRulesFull, _super);
    function InboxRulesFull(props) {
        var _this = _super.call(this, props) || this;
        setInboxRuleDiagnosticRequestStatus(0 /* NotInitiated */);
        initializeInboxRulesFolders();
        return _this;
    }
    InboxRulesFull.prototype.componentDidMount = function () {
        getInboxRules();
    };
    InboxRulesFull.prototype.render = function () {
        return isInboxRuleOptionEditState()
            ? this.renderInboxRulesEditPage()
            : this.renderRuleList();
    };
    /**
     * Gives back the list of rows depending on the status of getting inbox rules
     * @return inbox rule list
     */
    InboxRulesFull.prototype.renderRuleList = function () {
        var getInboxRuleRequestStatus = this.props.inboxRulesListState.getInboxRuleRequestStatus;
        return (React.createElement("div", null,
            React.createElement(OptionDescription, null, strings.options_inboxRules_description),
            React.createElement("div", { className: styles.actionLayer }, isControlFeatureEnabled('tri-rules-advanced') && (React.createElement(ActionButton, { className: styles.ruleCommandButton, onClick: function () { return initializeInboxRuleEdit(); }, text: strings.options_inboxRules_addNewRule, iconProps: {
                    iconName: "Add" /* Add */,
                    styles: {
                        root: className(styles.icon, 'flipForRtl'),
                    },
                } }))),
            this.getInboxRulesListContent(getInboxRuleRequestStatus)));
    };
    InboxRulesFull.prototype.getInboxRulesListContent = function (getInboxRuleRequestStatus) {
        switch (getInboxRuleRequestStatus) {
            case 2 /* Complete */:
                return this.renderRuleRows();
            case 3 /* Error */:
                return this.getInboxRuleError();
            case 1 /* Pending */:
            default:
                return React.createElement(Spinner, { className: styles.loadingSpinner, type: SpinnerType.large });
        }
    };
    /**
     * Creates error message div on get inbox rules error
     * @return error message div
     */
    InboxRulesFull.prototype.getInboxRuleError = function () {
        return (React.createElement(MessageBar, { messageBarType: MessageBarType.error, isMultiline: false, actions: React.createElement(DefaultButton, { onClick: function () {
                    getInboxRules();
                } }, strings.options_rules_tryAgain) }, strings.options_rules_loadingRulesError));
    };
    /**
     * Creates the rule rows in inbox rules settings page
     * @return inbox rule rows
     */
    InboxRulesFull.prototype.renderRuleRows = function () {
        var rows = [];
        var inboxRuleCollection = this.props.inboxRulesListState.inboxRuleIds;
        inboxRuleCollection.forEach(function (inboxRuleId) {
            rows.push(React.createElement(InboxRuleRow, { key: inboxRuleId, inboxRuleId: inboxRuleId }));
        });
        return (React.createElement("div", { className: styles.inboxRuleRowsContainer },
            rows.length > 0 ? (rows) : (React.createElement(OptionDescription, { className: styles.emptyRules }, strings.options_rules_noRules)),
            isControlFeatureEnabled('tri-rules-advanced') &&
                inboxRuleCollection.length > 0 &&
                this.renderDiagnosticButton()));
    };
    InboxRulesFull.prototype.renderDiagnosticButton = function () {
        switch (this.props.inboxRulesListState.getInboxRuleDiagnosticRequestStatus) {
            case 1 /* Pending */:
                return (React.createElement("div", { className: styles.diagnosticLoadingContainer },
                    React.createElement(Spinner, { className: styles.diagnosticSpinner, type: SpinnerType.normal }),
                    React.createElement("span", { className: styles.diagnosticLoadingText }, strings.options_inboxRules_generateReportPending)));
            case 3 /* Error */:
                return (React.createElement("span", { className: styles.diagnosticText }, strings.options_inboxRules_generateReportFail));
            case 2 /* Complete */:
                return (React.createElement("span", { className: styles.diagnosticText }, strings.options_inboxRules_generateReportSuccess));
            default:
                return (React.createElement("div", { className: styles.generateReportText },
                    React.createElement(ActionButton, { className: styles.ruleCommandButton, onClick: function () { return generateInboxRuleDiagnosticReport(); }, text: strings.options_inboxRules_generateReport })));
        }
    };
    InboxRulesFull.prototype.renderInboxRulesEditPage = function () {
        return React.createElement(InboxRulesEdit, null);
    };
    InboxRulesFull = tslib_1.__decorate([
        reactive({
            inboxRulesListState: function () { return store.inboxRulesListState; },
        })
    ], InboxRulesFull);
    return InboxRulesFull;
}(React.Component));
export default InboxRulesFull;
//# sourceMappingURL=InboxRulesFull.js.map